<script setup lang="ts">
import IOHeaderContainer from "@/components/io/io-header/IOHeaderContainer.vue";
import IOMobileHeader from "@/components/io/io/header/IOMobileHeader.vue";
const { $io } = useNuxtApp()

import { ioHeader, mobileMenuSnapPoint } from '@/io'
// Manage fixed state of the header
useNavigationFixedState(ioHeader)

const { width: ww, height: wh } = useWindowSize()
const MobileMenuActive = computed(() => ww.value < mobileMenuSnapPoint)
watch(MobileMenuActive, (active) => {
  $io.mobileMenuActive = active
}, {
  immediate: true
})

const props = withDefaults(defineProps<{
  primaryC?: string
  primaryW?: string
}>(), {
  primaryC: '',
  primaryW: 'flex g-1 mw-92 w-full mx-auto justify-between',
})


const isMounted = useMounted()

const headerFixed = computed(() => $io.headerFixed)
const headerFixedMini = computed(() => $io.headerFixedMini)
</script>

<template>
<div class="io-header" :class="[{ 'header-fixed': headerFixed }, { 'header-fixed-mini': headerFixedMini }]" >

  <slot name="before" />

  <IOHeaderContainer 
    class="layer layer-header-container z-15" 
    :class="primaryC"
    :w="primaryW"
    v-if="isMounted && !MobileMenuActive"
  >
    <slot name="header-before" />
    
    <slot name="primary">
      <Column class="module sec-branding">
        -- Branding -- 
      </Column>
      <Column class="module sec-navigation">
        -- Navigation --
      </Column>
      <Column class="module sec-actions">
      -- Actions --
      </Column>
    </slot>

    <slot name="header-after" />
  </IOHeaderContainer>

  <slot name="mobile">
    <IOMobileHeader>
      <template #flyoutheader>
        This is the flyout header 
      </template>
    </IOMobileHeader>
  </slot>

  <slot name="after" />

</div>
</template>

<style lang="scss" scoped>


.io-header {
  .primary-header-container {
    height: 100px;
  }
  &.header-fixed {
    // height: 80px;
    .primary-header-container {
      // height: 80px;
      height: 80px;
    }
  }
}


</style>
